// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DgeR","colBig":"styles_colBig__3Thqo","colSmall":"styles_colSmall__1bVoG"};